<!-- 投标控制预算审核意见表 -->
<template>
  <div>
    <div class="panel">
      <div class="label">工程名称</div>
      <div class="value3">
        {{ data.projectName }}
      </div>

      <div class="label">项目编号</div>
      <div class="value1">
        {{ data.designCode}}
      </div>

      <div class="label">招标控制价</div>
      <div class="value2">
        {{ data.bidPriceLimit}}
      </div>

      <div class="label">投标控制预算</div>
      <div class="value1">
        {{ data.bidBudget}}
      </div>

      <div class="label">拟投标价</div>
      <div class="value2">
        {{ data.bidPriceProposed }}
      </div>

      <div class="label">审核意见</div>
      <div class="value3">
        {{data.remark}}
      </div>

      <div class="label">附件</div>
      <div class="value3">
        <div v-if="Array.isArray(data.attachmentList)">
          <a v-for="(item) in data.attachmentList"
             :key="item.id"
             target="_blank"
             :href="item.completePath"
             style="display:block;">
            {{item.name}}
          </a>
        </div>
      </div>
    </div>
    <Padding />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState("approval", ["detail"]),
    data() {
      return this.detail.extra.budgetData ? this.detail.extra.budgetData : {};
    },
  },
};
</script>


<style lang="less" scoped>
.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  & > div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }
  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }
}
</style>

